module.exports = __webpack_public_path__ + "static/media/hero_white.a9dfa56a.svg";